import { RouteNode } from '@coool/route-node';
import { ToQueryParams } from './common.dto';
import { FileListRequestParams } from './file.dto';
import { FormResponseRequestParams } from './forms.dto';
import { KnowledgeBaseArticleListRequestParams } from './knowledge-base.dto';
import { TrackingEventRequestParams } from './tracking.dto';
import { VisitorListRequestParams } from './visitor.dto';

export const SERVER_URL_PREFIX = 'api';

export const ServerUrls = {
  VisitorPublic: new RouteNode('visitors-public', {
    Identify: new RouteNode('identify'),
    Errors: new RouteNode('errors', {
      Post: new RouteNode(),
    }),
    Traits: new RouteNode('traits'),
    Events: new RouteNode('events'),
    Forms: new RouteNode('forms', {
      ById: new RouteNode(':formId', {
        Get: new RouteNode(),

        Responses: new RouteNode('responses', {
          Post: new RouteNode(),
        }),
      }, {
        params: {
          formId: 'formId',
        },
      }),
    }),
    Checklists: new RouteNode('checklists', {
      ById: new RouteNode(':checklistId', {
        Get: new RouteNode(),

        State: new RouteNode('state', {
          Post: new RouteNode(),
        }),
      }, {
        params: {
          checklistId: 'checklistId',
        },
      }),
    }),
    Elements: new RouteNode('elements', {
      ById: new RouteNode(':elementId', {
        Get: new RouteNode(),
      }, {
        params: {
          elementId: 'elementId',
        },
      }),
    }),
  }),

  Visitors: new RouteNode('visitors', {
    Get: new RouteNode('', {}, {
      queryParams: {
        skip: 'skip',
        limit: 'limit',
        filter: 'filter',
      } satisfies ToQueryParams<VisitorListRequestParams>,
    }),

    ById: new RouteNode(':visitorId', {
      Get: new RouteNode(),
    }, {
      params: {
        visitorId: 'visitorId',
      },
    }),
  }),

  VisitorTraitTypes: new RouteNode('visitor-trait-types', {
    Get: new RouteNode(),
  }),

  Reports: new RouteNode('reports', {
    Visitors: new RouteNode('visitors', {
      MonthlyActive: new RouteNode('monthly-active'),
    }),
  }),

  TrackingEvents: new RouteNode('tracking-events', {
    Get: new RouteNode('', undefined, {
      queryParams: {
        visitor: 'visitor',
        skip: 'skip',
        limit: 'limit',
      } satisfies ToQueryParams<TrackingEventRequestParams>,
    }),

    ById: new RouteNode(':eventId', {
      Get: new RouteNode(),
    }, {
      params: {
        eventId: 'eventId',
      },
    }),
  }),

  Checklists: new RouteNode('checklists', {
    Get: new RouteNode(),
    Upsert: new RouteNode(),

    ById: new RouteNode(':checklistId', {
      Get: new RouteNode(),
      Delete: new RouteNode(),
    }, {
      params: {
        checklistId: 'checklistId',
      },
    }),
  }),

  Forms: new RouteNode('forms', {
    Get: new RouteNode(),
    Upsert: new RouteNode(),

    ById: new RouteNode(':formId', {
      Get: new RouteNode(),
      Delete: new RouteNode(),

      Responses: new RouteNode('responses', {
        Get: new RouteNode('', {}, {
          queryParams: {
            skip: 'skip',
            limit: 'limit',
          } satisfies ToQueryParams<FormResponseRequestParams>,
        }),

        ById: new RouteNode(':responseId', {
            Get: new RouteNode(),
          }, {
            params: {
              responseId: 'responseId',
            },
          },
        ),
      }),
    }, {
      params: {
        formId: 'formId',
      },
    }),
  }),

  Sites: new RouteNode('sites', {
    Get: new RouteNode(),
    Upsert: new RouteNode(),

    ById: new RouteNode(':siteId', {
      Get: new RouteNode(),
      Delete: new RouteNode(),
    }, {
      params: {
        siteId: 'siteId',
      },
    }),
  }),

  Companies: new RouteNode('companies', {
    GetAvailable: new RouteNode(),
    Create: new RouteNode(),

    Data: new RouteNode('data'),

    Members: new RouteNode('members', {
      Get: new RouteNode(),

      ById: new RouteNode(':memberId', {
        Update: new RouteNode(),
        Delete: new RouteNode(),
      }, {
        params: {
          memberId: 'memberId',
        },
      }),
    }),

    MemberInvites: new RouteNode('member-invites', {
      Get: new RouteNode(),
      Create: new RouteNode(),
      ById: new RouteNode(':inviteId', {
        Delete: new RouteNode(),
      }, {
        params: {
          inviteId: 'inviteId',
        },
      }),
    }),

    CompanyInvites: new RouteNode('company-invites', {
      Get: new RouteNode(),
      ById: new RouteNode(':inviteId', {
        Reject: new RouteNode('reject'),
        Accept: new RouteNode('accept'),
      }, {
        params: {
          inviteId: 'inviteId',
        },
      }),
    }),
  }),

  Subscriptions: new RouteNode('subscriptions', {
    Get: new RouteNode(),

    ById: new RouteNode(':subscriptionId', {
      ManagementLink: new RouteNode('management-link', {}),
    }, {
      params: {
        subscriptionId: 'subscriptionId',
      },
    }),
  }),

  Articles: new RouteNode('articles', {
    Get: new RouteNode('', {}, {
      queryParams: {
        skip: 'skip',
        limit: 'limit',
        filter: 'filter',
      } satisfies ToQueryParams<KnowledgeBaseArticleListRequestParams>,
    }),

    Upsert: new RouteNode(),

    ById: new RouteNode(':articleId', {
      Get: new RouteNode(),
      Delete: new RouteNode(),
    }, {
      params: {
        articleId: 'articleId',
      },
    }),
  }),

  Elements: new RouteNode('elements', {
    Get: new RouteNode('', undefined, {
      queryParams: {
        types: 'types',
      },
    }),

    Upsert: new RouteNode(),

    ById: new RouteNode(':elementId', {
      Get: new RouteNode(),
      Delete: new RouteNode(),
    }, {
      params: {
        elementId: 'elementId',
      },
    }),
  }),

  Hints: new RouteNode('hints', {
    Get: new RouteNode(),
    Upsert: new RouteNode(),

    ById: new RouteNode(':hintId', {
      Get: new RouteNode(),
      Delete: new RouteNode(),
    }, {
      params: {
        hintId: 'hintId',
      },
    }),
  }),

  Files: new RouteNode('files', {
    Get: new RouteNode('', {}, {
      queryParams: {
        skip: 'skip',
        limit: 'limit',
        filter: 'filter',
        type: 'type',
      } satisfies ToQueryParams<FileListRequestParams>,
    }),

    Upload: new RouteNode(),
  }),

  KnowledgeBaseCategories: new RouteNode('knowledge-base-categories', {
    Get: new RouteNode('', {}, {
      queryParams: {
        ids: 'ids',
      },
    }),
  }),

  KnowledgeBases: new RouteNode('knowledge-bases', {
    Get: new RouteNode(),
    Upsert: new RouteNode(),

    ById: new RouteNode(':knowledgeBaseId', {
      Get: new RouteNode(),
      Delete: new RouteNode(),

      Domains: new RouteNode('domains', {
        Get: new RouteNode(),
        Create: new RouteNode(),

        ById: new RouteNode(':domainId', {
          Delete: new RouteNode(),
        }, {
          params: {
            domainId: 'domainId',
          },
        }),
      }),

      Featured: new RouteNode('featured', {
        Get: new RouteNode(),
        Upsert: new RouteNode(),

        ById: new RouteNode(':featuredId', {
          Delete: new RouteNode(),
        }, {
          params: {
            featuredId: 'featuredId',
          },
        }),
      }),

      Categories: new RouteNode('categories', {
        Get: new RouteNode(),
        Upsert: new RouteNode(),

        ById: new RouteNode(':categoryId', {
          Delete: new RouteNode(),
        }, {
          params: {
            categoryId: 'categoryId',
          },
        }),
      }),
    }, {
      params: {
        knowledgeBaseId: 'knowledgeBaseId',
      },
    }),
  }),

  HelpSite: new RouteNode('help-site', {
    Data: new RouteNode('data', {
      Get: new RouteNode('', undefined, {
        queryParams: {
          language: 'language',
        },
      }),
    }),

    Categories: new RouteNode('categories', {
      ById: new RouteNode(':categoryId', {
        Articles: new RouteNode('articles', {
          Get: new RouteNode(),
        }),
      }, {
        params: {
          categoryId: 'categoryId',
        },
      }),
    }),

    Articles: new RouteNode('articles', {
      Get: new RouteNode('', undefined, {
        queryParams: {
          filter: 'filter',
        },
      }),
      GetByPart: new RouteNode('item', undefined, {
        queryParams: {
          part: 'part',
        },
      }),
    }),

    Featured: new RouteNode('featured', {
      Get: new RouteNode(),
    }),
  }),

  Authentications: new RouteNode('authentications', {
    Google: new RouteNode('google', {
      Login: new RouteNode('login'),
      Callback: new RouteNode('callback'),
    }),

    Password: new RouteNode('password', {
      Register: new RouteNode(''),
      Login: new RouteNode('login'),
      PasswordChange: new RouteNode('password-change'),
      PasswordReset: new RouteNode('password-reset', {
        CreatePasswordReset: new RouteNode(''),
        Validate: new RouteNode('validate'),
      }),
      Validate: new RouteNode('validate', {
        Again: new RouteNode('again'),
      }),
    }),

    Session: new RouteNode('session', {
      CreateNew: new RouteNode(),
    }),

    Logout: new RouteNode('logout'),
  }),

  Emails: new RouteNode('emails', {
    Unsubscribe: new RouteNode('unsubscribe', {}, {
      queryParams: {
        token: 'token',
      },
    }),
  }),

  Integrations: new RouteNode('integrations', {
    LemonSqueezy: new RouteNode('lemon-squeezy', {
      Webhook: new RouteNode('webhook'),
    }),
  }),

  Health: new RouteNode('health', {
    Check: new RouteNode(),
    HTMLCheck: new RouteNode('html'),
    Info: new RouteNode('info'),
  }),
};